exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-glide-el=\"controls\"] {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n@media (max-width: 640px) {\n[data-glide-el=\"controls\"] {\n    justify-content: center;\n}\n}\n", ""]);

// exports
